import SalesDailyReportLayout from './SalesDailyReportLayout';

export default SalesDailyReportLayout;
